import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { API_BASE } from '../api-base.token';

@Injectable({
  providedIn: 'root',
})
export class ExceptionsHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  get() {
    const exceptionsUrl = Location.joinWithSlash(this.apiBase, `exceptions`);

    return this.httpClient.get(exceptionsUrl);
  }
}
